<template>
    <a-modal
        centered
        :visible="visible"
        :keyboard="false"
        :maskClosable="false"
        title="收款渠道"
        @ok="on_submit"
        @cancel="cancel"
        :confirmLoading="submitting"
        :width="480"
        :after-close="after_close"
    >
        <a-form-model :model="form" ref="recharge-create" :rules="rules">
          <a-form-model-item label="名称" prop="name" >
            <a-input v-model="form.name"></a-input>
          </a-form-model-item>
            <a-form-model-item label="开户行" prop="bank" >
                <a-input v-model="form.bank"></a-input>
            </a-form-model-item>
            <a-form-model-item label="银行账号/支付宝/其他" prop="account">
                <a-input v-model="form.account"></a-input>
            </a-form-model-item>
            <a-form-model-item label="备注">
                <a-textarea v-model="form.remark"></a-textarea>
            </a-form-model-item>

        </a-form-model>
    </a-modal>
</template>
<script>
    let init_form = {
        amount: null,
        member_id: null,
        memo: null,
        screenshot: null,
    };
    import env from "../../../../../env";
    export default {
        props: {
            visible: {
                default: false,
            },
            record: null,
        },
        data() {
            return {
                action: env.base_url + "service/upload",
                submitting: false,
                uploading: false,
                callback: null,
                rules: {
                    name: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                    account: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                  bank: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                },
                form: null,
            };
        },
        created() {
            this.form = JSON.parse(JSON.stringify(init_form));
        },
        watch: {
            visible(e) {
                if (e && this.record) {
                    Object.keys(this.form).map((v) => {
                        if (Object.prototype.hasOwnProperty.call(this.record, v)) {
                            this.form[v] = this.record[v];
                        }
                    });
                }
            },
        },
        methods: {
            cancel() {
                this.$emit("close");
            },
            on_submit() {
                this.$refs["recharge-create"].validate((valid) => {
                    if (valid) {
                        this.submitting = true;
                        this.$http
                            .post("/finance/payment_channel/store", this.form)
                            .then((res) => {
                                if (res.success) {
                                    this.cancel();
                                  this.load();
                                  this.$message.success(res.message);
                                    if (this.callback) {
                                        this.callback();
                                    }
                                } else {
                                    this.$error({ title: "失败", centered: true, content: res.message });
                                }
                            })
                            .catch(() => {})
                            .then(() => {
                                this.submitting = false;
                            });
                    } else {
                        this.$message.error("请检查并填写完需要录入的内容");
                        return false;
                    }
                });
            },
            after_close() {
                this.$refs["recharge-create"].resetFields();

                this.form = JSON.parse(JSON.stringify(init_form));
            },
        },
    };
</script>
